<template>
  <b-overlay :show="loadingEvents" spinner-variant="primary">
    <k-data-table
      id="EventsTable"
      :options="dtOptions"
      :dataList="events"
      class="table-hover simple-table dataTable"
      ref="datatable"
    >
    </k-data-table>
    <k-subscribe-event
      :events="['data-update:event']"
      @action="GetEsemenyek"
    ></k-subscribe-event>
  </b-overlay>
</template>

<script>
import { mapGetters } from 'vuex';
import $ from 'jquery';
import { NotificationFunctions } from '../../functions/NotificationFunctions';
import { ModalFunctions } from '../../functions/ModalFunctions';
import { addTooltip } from '../../utils/common';
import { AppStoreTypes } from '../../store/modules/app';
import { AppFunctions } from '../../functions/AppFunctions';
import { esemenyNaptarService } from '../../services/EsemenyNaptarService';

export default {
  name: 'events-table',
  model: {
    prop: 'selected',
    event: 'change',
  },
  data() {
    return {
      loadingEvents: false,
      events: [],
    };
  },
  mounted() {},
  beforeDestroy() {},
  created() {
    this.GetEsemenyek();
  },
  methods: {
    SetSelectedItem(ids) {
      this.$emit('change', ids);
    },
    async GetEsemenyek() {
      this.loadingEvents = true;
      try {
        let events = await esemenyNaptarService.GetEsemenyek();
        this.events = Object.freeze(events);
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.loadingEvents = false;
    },
    DrawSelectsOnDT(ids) {
      var selected = ids
        .map((m) => {
          return `[data-id="${m.id}"]`;
        })
        .join(',');
      var selectedIdsInDt = Array.from(
        $(this.$refs.datatable.$el).DataTable().rows({ selected: true }).data()
      ).map((m) => m.Id);
      let removedFromDt = selectedIdsInDt.filter(
        (f) => !ids.some((s) => s.id == f)
      );

      let notSelected = removedFromDt
        .map((m) => {
          return `[data-id="${m}"]`;
        })
        .join(',');

      if (selected) {
        $(this.$refs.datatable.$el)
          .DataTable()
          .rows(selected, { selected: false })
          .select();
      }
      if (notSelected) {
        $(this.$refs.datatable.$el)
          .DataTable()
          .rows(notSelected, { selected: true })
          .deselect();
      }
    },
    async DeleteEvent(id) {
      let success = await NotificationFunctions.ConfirmModal(
        'Esemény törlése',
        'Biztos, hogy törli az eseményt?'
      );
      if (success) {
        try {
          await esemenyNaptarService.EsemenyTorlese({ id: id });
          this.GetEsemenyek();
        } catch (error) {
          NotificationFunctions.AjaxError({ error });
        }
      }
    },
  },
  computed: {
    ...mapGetters({ user: AppStoreTypes.user.get }),
    isGod() {
      return AppFunctions.IsGod(this.user);
    },
    isProjektAdmin() {
      return AppFunctions.IsProjektAdmin(this.user);
    },
    dtOptions() {
      let vm = this;
      let tableData = this.tableData;
      let dtOptions = {
        initComplete: function (settings, json) {
          var table = '#' + settings.sTableId;
          $(vm.$refs.datatable.$el)
            .DataTable()
            .on('select', function (e, dt, type, indexes) {
              let rows = dt.rows({ selected: true }).data();
              vm.SetSelectedItem(
                Array.from(rows).map((m) => {
                  return {
                    id: m.Id,
                    text: m.Nev,
                  };
                })
              );
            });
          $(vm.$refs.datatable.$el)
            .DataTable()
            .on('deselect', function (e, dt, type, indexes) {
              let rows = dt.rows({ selected: true }).data();
              vm.SetSelectedItem(
                Array.from(rows).map((m) => {
                  return {
                    id: m.Id,
                    text: m.Nev,
                  };
                })
              );
            });

          $(table + ' .clear-searchbar').click(function () {
            $('.dataTables_filter .form-control').val('');
            $(vm.$refs.datatable.$el).DataTable().search('').draw();
          });
        },
        mark: {
          className: 'mark-red',
        },
        order: [[4, 'desc']],
        bSortClasses: false,
        aoColumns: [
          {
            sTitle: 'Esemény neve',
            sClass: 'width-fit-content',
            mRender: function (data, type, row, meta) {
              return row.Nev;
            },
          },
          {
            sTitle: 'Esemény típusa',
            sClass: '',
            mRender: function (data, type, row, meta) {
              return row.EsemenyTipusa?.Nev ?? '-';
            },
          },
          {
            sTitle: 'Esemény dátuma',
            sClass: '',
            mRender: function (data, type, row, meta) {
              return row.Vege
                ? `${vm.$options.filters.toDateTime(
                    row.Kezdete
                  )} - ${vm.$options.filters.toDateTime(row.Vege)}`
                : vm.$options.filters.toDateTime(row.Kezdete);
            },
          },
          {
            sTitle: 'Esemény jellege',
            sClass: '',
            mRender: function (data, type, row, meta) {
              return row.Jellege?.Nev ?? '-';
            },
          },
          {
            sTitle: 'Módosító',
            sClass: '',
            mRender: function (data, type, row, meta) {
              return `${vm.$options.filters.toDateTime(
                row.UtolsoModositoFelhasznalo?.Datum
              )}<br/>${row.UtolsoModositoFelhasznalo?.Nev}`;
            },
          },
          {
            sTitle: '',
            sClass: 'd-print-none dt-td-noClick all',
            bSortable: false,
            mRender: function (data, type, row, meta) {
              return '<i class="fa fa-trash pointer delete-event" data-toggle="k-tooltip" title="Esemény törlése"></i>';
            },
          },
        ],
        pageLength: 25,
        responsive: false,
        deferRender: true,
        select: {
          style: 'multi',
          selector: 'td:first-child',
        },
        sDom: `<'row dt-panelmenu align-items-center'<'col-4 'i><'col-8 dt-search'<f>>> 
          <'row'<'col-sm-12'tr>>
          <'row dt-panelfooter mt-1'<'col-3' B><'col-9 dt-lp d-flex justify-content-end'l p>>`,
        //buttons: ['copy', 'excel', 'pdf', 'print'],
        drawCallback: function (settings) {
          var table = '#' + settings.sTableId + '_wrapper';
          var lastRowColSpan = settings.aoColumns.length;
          $('[data-toggle="k-tooltip"]').each(function () {
            addTooltip(this);
          });
        },
        createdRow: function (row, data, rowIndex) {
          $(row).attr('data-id', data.Id);
          $(row).find('td').addClass('pointer');
          $(row)
            .find('td')
            .not('.dt-td-noClick')
            .click(function (e) {
              let id = $(this).closest('tr').attr('data-id');
              if (!vm.isProjektAdmin && !vm.isGod) {
                return;
              }
              ModalFunctions.OpenModal('k-esemeny-kezelo-modal', { id: id });
            });

          $(row)
            .find('.delete-event')
            .click(function (e) {
              var id = $(this).closest('tr').attr('data-id');
              vm.DeleteEvent(id);
            });
        },
        buttons: [
          {
            extend: 'print',
            text: '<i class="fas fa-print text-grey"></i>',
            className: 'btn btn-primary',
          },
          {
            extend: 'excelHtml5',
            text: '<i class="fas fa-download mr-0 text-grey"></i>',
            className: 'btn btn-primary',
          },
        ],
      };

      return dtOptions;
    },
  },
  watch: {
    selected: {
      handler: async function (curr) {
        await this.$nextTick();
        this.DrawSelectsOnDT(curr);
      },
      deep: true,
    },
  },
  props: {
    selected: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>
